import React from "react";
import { Button } from "../../styles";
import { Status, Icon } from "../../Index/index-style";

import { useNavigate } from "react-router-dom";


const ProductStatus = (props) => {
    const navigate = useNavigate();
    const { status, productStatus, statusIcon, btnIcon, msgContent, eventChange, isStart, euInstall,sydneyRegionInstall, privateLinkStatus } = props;
    return (
        <div>
            <Status $issuccess={status}>
                <span>{productStatus}</span>
                <Icon className={statusIcon}></Icon>
            </Status>
            <p>
                <span>{msgContent}</span>
            </p>
            {status === "success" && btnIcon &&
                <>
                    <div className="installButtonStack">
                        <div className="columnStack">
                            <Button $position="right" onClick={() => eventChange('configuration')}>
                                <span className="install-submit">Standard Edition</span>
                                <i className={`button-icon ${btnIcon}`}></i>
                            </Button>
                            <p className="installMsg">Installs the application in the US East region. This is the recommended option for most users.</p>
                        </div>

                        {/* <div className="columnStack">

                            <Button $position="right" onClick={() => euInstall('configuration')}>
                                <span className="install-submit">EU Edition</span>
                                <i className={`button-icon ${btnIcon}`}></i>
                            </Button>
                            <p className="installMsg">Installs the application in the European Union (EU) region. This option is suitable for users who require <b> data residency within the EU.</b></p>
                        </div> */}
                    </div>
                </>
            }

            {status === "success" && statusIcon && isStart != true &&
                <>
                    <Button $position="right" onClick={() => navigate("/main")}>
                        <span className="install-submit">Finish</span>
                        <i className={`button-icon ${statusIcon}`}></i>
                    </Button>
                </>
            }
        </div>
    )
}

export default ProductStatus